import React from "react"
import { css } from "@emotion/core"
import styled from "@emotion/styled"
import PrettyBullet from "./pretty-bullet"

const Toc = styled.div`
  display: var(--no-mobile-block);
  list-style-type: none;
  position: sticky;
  top: 90px;
  font-size: 0.8rem;
  font-weight: bold;
  max-width: 250px;
  
  // display: flex;
  // left: calc(50% + 400px);
  // width: 310px;
`

const gradientText = css`
  background: var(--color-accent-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1.3px;
`

const InnerScroll = styled.div`
  overflow: auto;
  max-height: calc(70vh - 90px);
`

const ContentsList = ({ items }) => {
  return (
    <ul
      css={css`
        list-style-type: none;
        margin: 10px;
      `}
    >
      {items.map(item => {
        return <ContentsItem key={`${item.url}-item`} item={item} />
      })}
    </ul>
  )
}

const ContentsItem = ({ item }) => (
  <li css={css`
    text-decoration: none;
    margin-top: 15px;
  `}>
    {/* <PrettyBullet> */}
      <a
        css={css`
          text-decoration: none;
          color: var(--color-text);
          &:hover {
            color: var(--color-interactive-light);
          }
        `}
        href={item.url}
      >
        {item.title}
      </a>
    {/* </PrettyBullet> */}
    {/**
     * conditionally render another `ContentsList` within this `<li>`
     * if there is a `items` array within this `item`
     */}
    {item.items && item.items.length && (
      <ContentsList key={`${item.url}-list`} items={item.items} />
    )}
  </li>
)

export default function TableOfContents({ tableOfContents }) {
  return (
    <>
      {typeof tableOfContents.items === "undefined" ? null : (
        <Toc>
          <InnerScroll>
            <h4 css={css`
              ${gradientText}
              margin: 8px;
              margin-bottom: 25px;
              // margin-left: 34px;
            `}>TABLE OF CONTENTS</h4>
            <ContentsList items={tableOfContents.items} />
            {/* {tableOfContents.items.map(i => (
              <li key={i.url}>
                <a href={i.url} key={i.url}>
                  {i.title}
                </a>
              </li>
            ))} */}
          </InnerScroll>
        </Toc>
      )}
    </>
  )
}
